export const shallowCopy = value => {
  if (Array.isArray(value)) {
    return [...value];
  }
  if (typeof value === 'object' && value !== null) {
    return Object.assign({}, value);
  }
  return value;
};